module.exports = __webpack_public_path__ + "static/img/ikonaZdjecie-ON.d0057693.png";